import { Autocomplete, Chip, CircularProgress, styled } from '@mui/material';
import { LabeledTextField } from '@components/LabeledTextField';

const StyledChip = styled(Chip)(({ theme }) => ({
  lineHeight: 1,
  height: '20px',
  margin: `${theme.spacing(0, 0.5, 0, 0)} !important`,
}));

export interface LabeledMultiAutocompleteFieldProps {
  label: string;
  value?: string[];
  onChange: (value: string[]) => void;
  error?: boolean;
  helperText?: string;
  loading?: boolean;
  disabled?: boolean;
  options: string[];
  placeholder?: string;
}

export function LabeledMultiAutocompleteField({
  label,
  value = [],
  onChange,
  error,
  helperText,
  loading = false,
  disabled = false,
  options,
  placeholder,
}: LabeledMultiAutocompleteFieldProps) {
  return (
    <Autocomplete
      multiple
      freeSolo
      disabled={disabled}
      options={options}
      value={value || []}
      size="small"
      onChange={(_, newValue) => {
        if (newValue && Array.isArray(newValue)) onChange(newValue);
      }}
      renderInput={(params) => (
        <LabeledTextField
          {...params}
          optional
          label={label}
          error={error}
          helperText={helperText}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
            placeholder,
          }}
        />
      )}
      renderTags={(tagValue, getTagProps) =>
        tagValue.map((option, index) => (
          <StyledChip variant="filled" size="small" label={option} {...getTagProps({ index })} key={option} />
        ))
      }
    />
  );
}
